module.exports = __webpack_public_path__ + "static/media/sportradar-logo.5f060132.png";